// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__3Z8FL","open":"MenuToggle_open__3LZTs"};